import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('edit-social-media', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['viewport']),
  },
  name: 'edit-social-media',
  props: ['droplet', 'show-edit-bubble', 'icon-set'],
  data() {
    return {
      display: {
        newWindow: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.newWindow = this.droplet.newWindow;
    },
    toggleIcon(index, icon) {
      const payload = {};
      payload.drp = this.droplet;
      payload.active = !icon.active;
      payload.index = index;
      this.$store.dispatch('setSocialActive', payload);
    },
    updateLink(e, i) {
      const val = e.currentTarget.value;
      this._debounce(() => {
        const payload = {};
        payload.drp = this.droplet;
        payload.link = val.trim() === '' ? false : val;
        payload.index = i;
        this.$store.dispatch('setSocialLink', payload);
      }, 200);
    },
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.$emit('css-generator');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/social-media/components/_edit-options/index.js